import React from "react";
import { regex, required, useInput } from "react-admin";
import { Marker } from "@react-google-maps/api";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import _ from "lodash";
import { stringToLatLng, latLon_rgx } from "./helpers";
import GoogleMaps from "./GoogleMaps";
import Box from "@mui/material/Box";

const RootPaper = styled(Paper)({
  position: "absolute",
  bottom: "10px",
  left: "10px",
  zIndex: 1,
  padding: "2px 4px",
  display: "flex",
  alignItems: "center",
  width: "240px",
  backgroundColor: "white",
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.3)",
});

const StyledTypography = styled(Typography)({
  position: "absolute",
  top: "0",
  left: "10px",
  marginTop: "0",
  zIndex: 1,
  backgroundColor: "white",
});

const StyledInputBase = styled(InputBase)({
  flex: 1,
});

const LatLongTextInput = (props) => {
  const { submit, onChange: customOnChange, ...restProps } = props;

  const {
    field: { name, onChange, onBlur, value, ...restInput },
    fieldState: { error },
  } = useInput({
    ...restProps,
    validate: [required(), regex(latLon_rgx, "احداثي غير صحيح")],
  });

  const onTxtBoxChange = (event) => {
    const latLngStr = event.currentTarget.value;
    const regexError = !latLon_rgx.test(latLngStr);
    const latLng = !regexError && stringToLatLng(event.currentTarget.value);
    onChange(latLng || latLngStr);
    customOnChange && customOnChange(latLngStr);
  };

  return (
    <>
      <RootPaper>
        <StyledInputBase
          id={name}
          placeholder="Latitude, Longitude"
          inputProps={{ "aria-label": "Latitude, Longitude" }}
          {...restInput}
          onChange={onTxtBoxChange}
          onBlur={onBlur}
          value={
            typeof value === "object"
              ? `${value.lat.toFixed(7)}, ${value.lng.toFixed(7)}`
              : value
          }
          error={!!error}
        />
      </RootPaper>
      {error && (
        <StyledTypography variant="caption" color="error">
          {error.message}
        </StyledTypography>
      )}
    </>
  );
};

const GeoLocationInput = (props) => {
  const { style, ...restProps } = props;
  const {
    field: { onChange, value },
  } = useInput(restProps);
  const MAP = React.useRef(undefined);
  const validGPSPosition = typeof value === "object" && value;

  const onTxtBoxChange = (latLng) => {
    latLon_rgx.test(latLng) && MAP.current && MAP.current.setCenter(stringToLatLng(latLng));
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        موقع وجهة الرحلة
      </Typography>

      <div style={style || { width: "100%", height: "50vmin" }}>
        <GoogleMaps
          onClick={(e) => {
            onChange({ lat: e.latLng.lat(), lng: e.latLng.lng() });
          }}
          onLoad={(map) => {
            MAP.current = map;
            validGPSPosition && map.setCenter(validGPSPosition);
          }}
          mapProps={{
            mapContainerStyle: {
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column-reverse",
            },
            mapTypeId: "hybrid",
          }}
        >
          <LatLongTextInput source={props.source} onChange={onTxtBoxChange} />
          {validGPSPosition && <Marker position={validGPSPosition} />}
        </GoogleMaps>
      </div>
    </Box>
  );
};

export default GeoLocationInput;
